module.exports = __webpack_public_path__ + "img/DE03669.50f1e5bc.png";